import createErrors from '../createErrors';
import { type Page } from './constants';

export type Component = 'MiniPdpAutoship';

/**
 * Errors related to the Autoship option on the Mini PDP drawer
 */
export const Errors = createErrors<Page, Component>('PDP')({
    MiniPdpAutoship: {
        FetchSubscriptionsFailed: {
            severity: 'MEDIUM',
            message: 'Failed to fetch customer Autoship subscriptions',
        },
    },
});
